import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../../../components/ui/dialog';
import { HelpCircle } from 'lucide-react';
import { GRUPO_BY_KEY } from '../glosarioData';

// Ícono "?" que abre un modal con el glosario de una única sección.
export const GlosarioHelpButton = ({ seccion, testId = 'glosario-help-btn' }) => {
  const [open, setOpen] = useState(false);
  const g = GRUPO_BY_KEY[seccion];
  if (!g) return null;
  const Icon = g.icon;
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        title={`Glosario · ${g.titulo}`}
        aria-label={`Glosario de ${g.titulo}`}
        className="inline-flex items-center justify-center h-9 w-9 rounded-full border border-slate-200 dark:border-slate-700 text-slate-400 hover:text-indigo-600 hover:border-indigo-300 hover:bg-indigo-50/50 dark:hover:bg-indigo-500/10 transition-colors"
        data-testid={testId}
      >
        <HelpCircle className="h-5 w-5" />
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg max-h-[80vh] overflow-y-auto" data-testid={`${testId}-dialog`}>
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <span className="p-1.5 rounded-lg" style={{ backgroundColor: `${g.color}1a` }}>
                {Icon && <Icon className="h-5 w-5" style={{ color: g.color }} />}
              </span>
              Glosario · {g.titulo}
            </DialogTitle>
            <DialogDescription>Cómo se calcula cada métrica de esta sección.</DialogDescription>
          </DialogHeader>
          <dl className="space-y-4 mt-2">
            {g.terminos.map((x, i) => (
              <div key={i} className="border-l-2 pl-3" style={{ borderColor: g.color }} data-testid={`${testId}-term-${i}`}>
                <dt className="font-semibold text-slate-800 dark:text-slate-200 text-sm">{x.t}</dt>
                <dd className="text-sm text-slate-500 dark:text-slate-400 mt-0.5">{x.d}</dd>
                <dd className="text-xs text-slate-400 mt-1 font-mono bg-slate-50 dark:bg-slate-800/60 rounded px-2 py-1">ƒ {x.f}</dd>
              </div>
            ))}
          </dl>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default GlosarioHelpButton;
